// extracted by mini-css-extract-plugin
export default {"panel":"filters-panel_panel__Eunew","input":"filters-panel_input__W-54E","sort":"filters-panel_sort__RuvKG","tabs":"filters-panel_tabs__KIxBJ","tab":"filters-panel_tab__saecm"};